import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-765e8e8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-names-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "with-subhead" }, " Common names "),
    /*#__PURE__*/_createElementVNode("p", { class: "subhead" }, " The most common surnames and given names in your family tree. ")
  ])
], -1))
const _hoisted_3 = {
  class: "btn-group part-select",
  role: "group",
  "aria-label": "Name part button group"
}
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = ["for"]

import { computed, ref } from 'vue'
import { useNameCounts } from './NameCounts'
import ScopeLoadProgress from '@/explore/ScopeLoadProgress.vue'
import NameStreamgraph from './NameStreamgraph.vue'
import { PersonNamePart } from '@/rd/ResearchDataModel'
import { useExploreStore } from '@/explore/ExploreStore'
import { useViewScopeStore } from '@/explore/ViewScopeStore'
import { LoadMode } from '@/util/AsyncData'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNamesPage',
  setup(__props) {

const exploreStore = useExploreStore()
const viewScopeStore = useViewScopeStore()
const scopeLoading = computed(() => !viewScopeStore.getAsyncScopeInfo(exploreStore.startPersonId, LoadMode.EnsureLoaded)?.isLoaded)

const nameParts = [
  { id: 's', text: 'Surnames' },
  { id: 'g:male', text: 'Male names' },
  { id: 'g:female', text: 'Female names' },
]

const selectedPartIdRef = ref(nameParts[0].id)

const nameCounts = useNameCounts()

const timeDataRef = computed(() => nameCounts.nameTimeData.get(selectedPartIdRef.value) ?? [])
const namePartRef = computed(() => selectedPartIdRef.value === 's' ? PersonNamePart.Surname : PersonNamePart.Given)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (scopeLoading.value)
      ? (_openBlock(), _createBlock(ScopeLoadProgress, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(nameParts, (part) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: part.id
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "btn-check",
                  name: "part",
                  id: part.id,
                  autocomplete: "off",
                  value: part.id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPartIdRef).value = $event))
                }, null, 8, _hoisted_4), [
                  [_vModelRadio, selectedPartIdRef.value]
                ]),
                _createElementVNode("label", {
                  class: "btn btn-outline-primary btn-sm",
                  for: part.id
                }, _toDisplayString(part.text), 9, _hoisted_5)
              ], 64))
            }), 64))
          ]),
          (timeDataRef.value.length)
            ? (_openBlock(), _createBlock(NameStreamgraph, {
                key: selectedPartIdRef.value,
                data: timeDataRef.value,
                "name-part": namePartRef.value
              }, null, 8, ["data", "name-part"]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})